<template>
  <div class="p-page-wrapper">
    <p-routed-tabs
      :tabs="tabs"
      class="pt-1"
    ></p-routed-tabs>
    <router-view/>
  </div>
</template>


<script>
import { mapActions } from 'vuex'

import PRoutedTabs from '@/components/PRoutedTabs'

import pageMixin from '@/mixins/page.mixin'

export default {
  components: {
    PRoutedTabs
  },


  mixins: [
    pageMixin
  ],


  data () {
    return {
      tabs: [
        { title: this.$t('userAccess.tabs.schemes'), route: 'settingsUsersAccessSchemes' },
        { title: this.$t('userAccess.tabs.projects'), route: 'settingsUsersAccessProjects' }
      ]
    }
  },


  methods: {
    ...mapActions('user', ['loadUsers']),

    async onTabsInit () {
      try {
        this.setPageTitle(this.$t('nav.userAccess'))
        await this.loadUsers()
      } catch (error) {
        this.$log.error(error)
      }
    }
  }
}
</script>
